/*
 * The four seeded admin roles as the Admins screen presents them (admin-ui.md → Admins; the
 * backend seed in packages/database/src/seed/rbac.ts is the source of truth for the ids). Label and
 * description are the operator-facing copy from the design; `SUPER_ADMIN` is the only role the
 * last-active guard protects. Ordered most- to least-privileged, the order the role pickers render.
 */

export const SUPER_ADMIN_ROLE = 'SUPER_ADMIN';

export interface RoleMeta {
  readonly id: string;
  readonly label: string;
  readonly description: string;
}

export const ROLES: readonly RoleMeta[] = [
  {
    id: 'SUPER_ADMIN',
    label: 'Super Admin',
    description: 'Full access, including managing admins.',
  },
  {
    id: 'GAME_MANAGER',
    label: 'Game Manager',
    description: 'Everything except managing admins.',
  },
  {
    id: 'SETTLEMENT',
    label: 'Settlement',
    description: 'Settlement, awards retry, and read access.',
  },
  {
    id: 'OPS_SUPPORT',
    label: 'Ops Support',
    description: 'Read-only across contests, players, and awards.',
  },
];

const ROLE_BY_ID = new Map(ROLES.map((role) => [role.id, role]));

/** The display label for a role id, falling back to the raw id for a role the UI doesn't know. */
export function roleLabel(roleId: string): string {
  return ROLE_BY_ID.get(roleId)?.label ?? roleId;
}
